export const RELEVANT_RADIO_BUTTON_ID   = "relevantOption"
export const RELEVANT_RADIO_BUTTON_NAME = "relevant"
export const RELEVANT_OPTION_VALUE      = "true"

export const IRRELEVANT_RADIO_BUTTON_ID   = "irrelevantOption"
export const IRRELEVANT_RADIO_BUTTON_NAME = "irrelevant"
export const IRRELEVANT_OPTION_VALUE      = "false"



// WEBPACK FOOTER //
// ./src/features/home/components/comment-filter/constants/RelevanceFilterConstants.js